import React, { Component } from "react";
import ReactDOM from "react-dom";
import { brow } from 'react-router';
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LinkSite from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Circular from "components/Circular/Circular";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import icon from "../../assets/img/icon.png";
import correiosLogo from "../../assets/img/meulocker_logo.png";
import backgroundImage from "../../assets/img/condominio_sigin.jpg"

import { login as authenticate } from "services/customer/index";

const useStyles = (theme) => ({
  root: {
    height: "100vh",
    "& .MuiTypography-root": {
      padding: "20px 0 0 0",
    },
  },
  image: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type ==="dark"
        ? theme.palette.grey[900]
        : theme.palette.grey[50],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paperBackground: {
    background: "#F1F1F2",
  },
  img: {
    width: '60%',
    //marginBottom: '-10%'
  },
  span: {
    "& .MuiTypography-root": {
      color: "gray",
    },
    display: "block !important",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  green: {
    "& label.Mui-focused": {
      color: "green",
    },

    borderColor: "green !important",
  },
  red: {
    "& label.Mui-focused": {
      color: "red",
    },
    color: "red",
    borderColor: "red !important",
  },
  circular: {
    position: "absolute !important",
    top: "320px !important",
  },
});

class SignInSide extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.copyright = this.copyright.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    //this.history = useHistory();
    this.state = {
      username: "",
      password: "",
      error: false,
      invalid: false,
      circular: false,
    };
  }

  handleUserChange(e) {
    this.setState({ username: e.target.value, error: false, invalid: false });
  }

  handlePassChange(e) {
    this.setState({ password: e.target.value, error: false, invalid: false });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({ circular: true }, () => {
      let { username, password } = this.state;
      if (!username || !password) {
        return this.setState({ error: true, circular: false });
      }

      authenticate(username, password, false, (token) => {
        if (token) {
          createBrowserHistory({ forceRefresh: true }).push("/");

        } else {
          this.setState({ invalid: true, circular: false });
        }
      });
    });
  }

  copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <LinkSite color="inherit" href="http://qira.com.br/">
          Qirá Tecnologia
        </LinkSite>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }

  render() {
    let { classes } = this.props;
    let { error, invalid, username, password, circular } = this.state;

    return (
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          className={classes.paperBackground}
        >
          <div className={classes.paper}>
            <img src={correiosLogo} className={classes.img} />
            <Typography component="h1" variant="h5">
              {circular ? null : ""}
            </Typography>
            {circular ? (
              <div className={classes.circular}>
                <Circular />
              </div>
            ) : (
                <form
                  className={classes.form}
                  noValidate
                  onSubmit={this.handleSubmit}
                >
                  <TextField
                    className={error && !username ? classes.red : classes.green}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    InputProps={{
                      classes: {
                        notchedOutline:
                          error && !username ? classes.red : classes.green,
                      },
                    }}
                    id="email"
                    label="email"
                    name="email"
                    //autoComplete="email"
                    autoFocus
                    value={username}
                    onChange={this.handleUserChange}
                  />
                  <TextField
                    className={error && !password ? classes.red : classes.green}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    InputProps={{
                      classes: {
                        notchedOutline:
                          error && !password ? classes.red : classes.green,
                      },
                    }}
                    name="password"
                    label="Senha"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={this.handlePassChange}
                  />
                  {invalid ? (
                    <p className={classes.red}>Matrícula ou Senha Inválido!</p>
                  ) : null}
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                  >
                    Log In
                </Button>
                  {/* <Grid container>
                  <Grid item xs>
                    <LinkSite href="#" variant="body2">
                      Esqueceu a senha?
                    </LinkSite>
                  </Grid>
                  <Grid item>
                    <LinkSite href="/signUp" variant="body2">
                      {"Ainda não tem conta? Registrar"}
                    </LinkSite>
                  </Grid>
                </Grid> */}
                  <Box mt={5}>{this.copyright}</Box>
                </form>
              )}
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(SignInSide);
